import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { Context } from './ListadoTasasValoresScreen'
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import PercentIcon from '@mui/icons-material/Percent';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ValTasaInteresValores } from './ValTasaInteresValores';
import { LoaderScreen } from '../../components/LoaderScreen';

const ModalTasasValoresScree = ({ idtasa_valor, idtasa, updatedata, descripcion, onClose }) => {
    const { state, setState } = useContext(Context);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    //datos a guardar
    const [intereses, setIntereses] = useState({
        idtipo_tasa_valor: -999,
        idtipo_tasa: 0,
        plazo: 0,
        porcentaje: 0,
        bplazo: false,
        bporcentaje: false,
    });

    const closeModal = () => {
        setState({
            ...state,
            open: false,
        });

        onClose()
    };

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setIntereses({
            ...intereses,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };

    const Editar = () => {

        if (idtasa_valor !== null || idtasa_valor !== "" || idtasa_valor !== -999 || idtasa_valor !== undefined) {
            request
                .get(`FTasaInteresValores/BuscarID?idtipo_tasa_valor=${idtasa_valor}`)
                .then((result) => {
                    setIntereses({
                        ...intereses,
                        idtipo_tasa_valor: result.idtipo_tasa_valor,
                        idtipo_tasa: result.idtipo_tasa,
                        plazo: result.plazo,
                        porcentaje: result.porcentaje,
                    });
                })
                .catch((error) => {
                    Swal.fire("TASA DE INTERESES", JSON.stringify(error), "error");
                });
        } else {
            return;
        }
    }
    useEffect(() => {

        if (idtasa_valor !== undefined && idtasa_valor !== null && Number(idtasa_valor) > 0) {
            Editar();
        } else {
            setIntereses({
                ...intereses,
                idtipo_tasa_valor: -999,
                idtipo_tasa: "",
                plazo: "",
                porcentaje: "",
                bplazo: false,
                bporcentaje: false,
            })
        }
    }, [idtasa_valor]);


    const onGuardar = () => {
        var result = ValTasaInteresValores(intereses);
        if (result.isValid === false) {
            Swal.fire(
                "TASA DE INTERESES",
                JSON.stringify(result.mensaje),
                "error"
            );
        }
        else {
            result.post.idtipo_tasa_valor = intereses.idtipo_tasa_valor;
            result.post.idtipo_tasa = idtasa;
            setLoader({ ...loader, mostrar: true });

            request
                .post("FTasaInteresValores", result.post)
                .then(async () => {
                    setLoader({ ...loader, mostrar: false });
                    updatedata()

                    await Swal.fire({
                        title: "TASA DE INTERESES",
                        text: "Registro guardado con éxito",
                        icon: "success",
                        customClass: {
                            container: "mi-superpoop",
                        },
                    });
                    closeModal();
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("DOCUMENTOS", JSON.stringify(error), "error");
                });

        }
    };

    return (
        <Modal open={state.open}>
            <div className="dash-clientes-credito-crear-solicitud-modal">
                <div className="credito-agregar-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>AGREGAR INTERESES {descripcion.toUpperCase()}</h3>
                    </div>
                </div>
                <div className="filtro-soy-el-titulo-line">
                    <div className="filtro-soy-el-titulo-line-bl"></div>
                    <div className="filtro-soy-el-titulo-line-circle"></div>
                    <div className="filtro-soy-el-titulo-line-br"></div>
                </div>
                <div className=''></div>

                <div className='modal-tasa-intereses-modal-inputs'>

                    <div>
                        <TextField
                            id="clientes-documento"
                            label="PLAZO"
                            type="number"
                            value={intereses.plazo}
                            onChange={({ target }) => {
                                setIntereses({
                                    ...intereses,

                                    plazo: target.value,
                                    bplazo: false,
                                });
                            }}
                            sx={{ mb: 2, width: 350 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CalendarMonthIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>

                    <div className="">

                        <TextField
                            id="clientes-documento"
                            label="PORCENTAJE"
                            type="number"
                            value={intereses.porcentaje}
                            onChange={({ target }) => {
                                setIntereses({
                                    ...intereses,

                                    porcentaje: target.value,
                                    bporcentaje: false,
                                });
                            }}
                            sx={{ mb: 2, width: 350 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <PercentIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />

                    </div>

                </div>

                <div className="credito-agregar-tasa-interes-valor-modal-button-container">
                    <Button onClick={closeModal} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalTasasValoresScree
